import {useState} from "preact/compat";

export const useAttendanceRegion = (props) => {
    // State to control the dropdown display state
    const [isOpen, setIsOpen] = useState(false);

    // Method to handle the dropdown button action
    const handleOpen = () => {
        setIsOpen(prevState => !prevState);
    }

    return {
        isOpen,
        handleOpen
    }
}
